export class ProductCard extends HTMLElement {
  connectedCallback() {
    this.infoButton = this.querySelector('[data-info-button]');
    this.infoOverlay = this.querySelector('[data-info-overlay]');
    this.closeButton = this.querySelector('[data-close-button]');
    this.fadeOverlay = this.querySelector('.overlay-fade-overlay');

    // SM cards render neither the info button nor the overlay (NGE-15018).
    // Arrow fields keep one identity per instance, so disconnectedCallback's
    // removeEventListener actually matches (a fresh .bind() never does).
    this.infoButton?.addEventListener('click', this.showOverlay);
    this.closeButton?.addEventListener('click', this.hideOverlay);

    this.addEventListener('click', this.handleOutsideClick);
  }

  showOverlay = () => {
    this.infoOverlay.classList.remove('opacity-0', 'invisible');
    this.infoOverlay.classList.add('opacity-100', 'visible');
    this.infoOverlay.setAttribute('aria-hidden', 'false');
    this.infoOverlay.classList.remove('scale-95');
    this.infoOverlay.classList.remove('rounded-2xl');
    this.infoOverlay.classList.remove('translate-y-12');
  };

  hideOverlay = () => {
    this.infoOverlay.classList.remove('opacity-100', 'visible');
    this.infoOverlay.classList.add('opacity-0', 'invisible');
    this.infoOverlay.setAttribute('aria-hidden', 'true');
    this.infoOverlay.classList.add('scale-95');
    this.infoOverlay.classList.add('rounded-2xl');
    this.infoOverlay.classList.add('translate-y-12');
  };

  handleOutsideClick = (event) => {
    if (event.target === this.infoOverlay) this.hideOverlay();
  };

  disconnectedCallback() {
    this.infoButton?.removeEventListener('click', this.showOverlay);
    this.closeButton?.removeEventListener('click', this.hideOverlay);
    this.removeEventListener('click', this.handleOutsideClick);
  }
}

customElements.define('product-card', ProductCard);
